var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEggLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 50,
    viewBox: "0 0 36 50",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_96)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 50C-12.6853 50 1.74714 0 18 0C34.2529 0.137994 48.6853 50 18 50Z",
    fill: "#FFCE00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7448 7.42383C23.8844 7.42383 21.9229 13.6559 21.9229 14.9034C21.9229 16.2889 23.3246 16.9803 23.7448 18.6432C23.8844 19.8893 23.0439 20.9975 23.1849 21.8282C23.4656 23.0744 25.5666 22.659 25.7076 23.9051C25.568 25.4286 24.5866 26.2594 24.306 27.6449C24.7262 27.7829 25.1464 27.7829 25.2874 27.9223C25.427 28.0603 21.0839 34.0163 21.5041 35.2625C20.6637 34.2923 21.7847 33.0462 22.3445 32.0774C22.9043 30.9693 23.6052 30.0006 23.8858 28.8924C23.7462 28.615 23.0453 28.8924 23.0453 28.477C23.326 26.8155 24.447 25.292 24.306 24.3219C24.4456 23.9065 22.4841 22.521 20.9429 21.5522C19.8218 20.9989 19.5412 20.3061 15.7579 20.5821C15.4773 20.5821 14.7765 20.3047 14.7765 19.8893C15.7579 21.2749 17.2992 19.474 18.98 19.8893C20.2407 20.1667 21.7819 20.8595 22.2021 20.8595C22.4827 20.4441 23.0425 20.0287 22.7619 18.9206C22.4813 17.9504 21.2207 17.3971 20.9401 16.1509C20.5199 14.6274 21.7805 11.5804 21.7805 11.5804C21.7805 11.5804 23.4613 7.42522 23.7419 7.42522",
    fill: "#37474F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_96"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEggLogo);
export default __webpack_public_path__ + "static/media/egg_logo.6227fac07505bfd4f4dbb6b5c325bb08.svg";
export { ForwardRef as ReactComponent };